import { render, staticRenderFns } from "./AddDataPanel.vue?vue&type=template&id=a1ad57d0&scoped=true&"
import script from "./AddDataPanel.vue?vue&type=script&lang=js&"
export * from "./AddDataPanel.vue?vue&type=script&lang=js&"
import style0 from "./AddDataPanel.vue?vue&type=style&index=0&id=a1ad57d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ad57d0",
  null
  
)

export default component.exports